// Auto-generated by scripts/generate-registry.mjs from packages/modules/youtube_short_spiral_lamp/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const youtube_short_spiral_lamp: ModuleSchema = {
  "id": "youtube_short_spiral_lamp",
  "uniqueId": "B3D_3LH3W",
  "createdAt": "2026-10-07T00:00:00Z",
  "updatedAt": "2026-10-12T14:12:40.213Z",
  "label": "Twisted Rib",
  "description": "16 outer spiral ribs interweave with 11 thicker inner ribs, ending at a clear 70 mm mouth; the shade screws directly onto the M60 base post.",
  "category": "lighting",
  "tags": [
    "lamp",
    "spiral",
    "twisted ribs",
    "fluted",
    "shade",
    "e27",
    "table lamp"
  ],
  "sliders": [
    {
      "key": "totalHeight",
      "label": "Shade Height",
      "min": 100,
      "max": 300,
      "default": 202,
      "step": 5,
      "unit": "mm"
    },
    {
      "key": "shadeMaxDia",
      "label": "Maximum Shade Diameter",
      "min": 80,
      "max": 200,
      "default": 140,
      "step": 2,
      "unit": "mm"
    },
    {
      "key": "shadeTopDia",
      "label": "Clear Top Mouth Diameter",
      "min": 50,
      "max": 140,
      "default": 64,
      "step": 2,
      "unit": "mm"
    },
    {
      "key": "shadeBotDia",
      "label": "Bottom Shade Diameter",
      "min": 50,
      "max": 140,
      "default": 110,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "waistDia",
      "label": "Waist Diameter",
      "min": 50,
      "max": 130,
      "default": 72.5,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "waistPosition",
      "label": "Waist Height Position",
      "min": 0.25,
      "max": 0.65,
      "default": 0.36,
      "step": 0.01,
      "unit": "ratio"
    },
    {
      "key": "waistWidth",
      "label": "Waist Transition Width",
      "min": 0.08,
      "max": 0.24,
      "default": 0.14,
      "step": 0.01,
      "unit": "ratio"
    },
    {
      "key": "closedWallRatio",
      "label": "Closed Lower Wall Height",
      "min": 0.2,
      "max": 0.5,
      "default": 0.33,
      "step": 0.01,
      "unit": "height ratio"
    },
    {
      "key": "turnCount",
      "label": "Total Twist Turns",
      "min": 0.05,
      "max": 3,
      "default": 1.1,
      "step": 0.05,
      "unit": "turns"
    },
    {
      "key": "spreadStart",
      "label": "Pitch Expansion Start",
      "min": 0.25,
      "max": 0.85,
      "default": 0.36,
      "step": 0.01,
      "unit": "height ratio"
    },
    {
      "key": "pitchExpansion",
      "label": "Upper Pitch Expansion",
      "min": 1.2,
      "max": 4,
      "default": 4,
      "step": 0.1,
      "unit": "×"
    },
    {
      "key": "ribCount",
      "label": "Number of Ribs",
      "min": 6,
      "max": 32,
      "default": 16,
      "step": 1,
      "unit": "ribs",
      "integerOnly": true
    },
    {
      "key": "ribWidth",
      "label": "Eye Length Toward Center",
      "min": 14,
      "max": 28,
      "default": 16,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "ribThickness",
      "label": "Eye Thickness Around Ring",
      "min": 12,
      "max": 24,
      "default": 14,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "baseHeight",
      "label": "Low Base Height",
      "min": 10,
      "max": 80,
      "default": 10,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "baseDia",
      "label": "Low Base Diameter",
      "min": 70,
      "max": 150,
      "default": 110,
      "step": 2,
      "unit": "mm"
    },
    {
      "key": "baseCornerRadius",
      "label": "Low Base Edge Radius",
      "min": 0,
      "max": 8,
      "default": 1,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "cableHoleDia",
      "label": "Cable Passage Diameter",
      "min": 12,
      "max": 12,
      "default": 12,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "cableTunnelPadWidth",
      "label": "Cable Opening Width at Bottom",
      "min": 3,
      "max": 8,
      "default": 4.5,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "screwThreadRadialClearance",
      "label": "Screw Thread Clearance per Side",
      "min": 0.2,
      "max": 0.8,
      "default": 0.4,
      "step": 0.05,
      "unit": "mm"
    },
    {
      "key": "segments",
      "label": "Circular Resolution",
      "min": 48,
      "max": 256,
      "default": 128,
      "step": 16,
      "unit": "segments",
      "integerOnly": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "low_base",
      "label": "E27 Low Threaded Base",
      "default": "#3C4548",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "shade_body",
      "label": "Twisted Rib Shade",
      "default": "#E7E4DC",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "screw_feet",
      "label": "4x M8 Feet Screws",
      "default": "#9CA3AF",
      "targetGroupIds": [
        2
      ]
    }
  ],
  "objects": [
    {
      "id": "lamp_base",
      "label": "E27 Lamp Base",
      "name": "E27 Lamp Base",
      "color": "#3C4548",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "low_base",
          "label": "E27 Low Threaded Base",
          "name": "E27 Low Threaded Base",
          "groupId": 1,
          "colorKey": "low_base",
          "defaultColor": "#3C4548",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "twisted_shade",
      "label": "Twisted Rib Shade",
      "name": "Twisted Rib Shade",
      "color": "#E7E4DC",
      "assembled_z_offset": 0,
      "exploded_z_offset": 55,
      "parts": [
        {
          "id": "shade_body",
          "label": "Twisted Rib Shade",
          "name": "Twisted Rib Shade",
          "groupId": 0,
          "colorKey": "shade_body",
          "defaultColor": "#E7E4DC",
          "assembled_z_offset": 0,
          "exploded_z_offset": 55,
          "export_stl": true
        }
      ]
    },
    {
      "id": "base_screws",
      "label": "4x M8 Base Foot Screws",
      "name": "4x M8 Base Foot Screws",
      "color": "#9CA3AF",
      "assembled_z_offset": 0,
      "exploded_z_offset": -25,
      "parts": [
        {
          "id": "screw_feet",
          "label": "4x M8 Feet Screws",
          "name": "4x M8 Feet Screws",
          "groupId": 2,
          "colorKey": "screw_feet",
          "defaultColor": "#9CA3AF",
          "assembled_z_offset": 0,
          "exploded_z_offset": -25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download 3MF/STL - Complete Lamp"
    },
    {
      "id": "shade",
      "label": "Download STL - Twisted Rib Shade"
    },
    {
      "id": "base",
      "label": "Download STL - E27 Base"
    },
    {
      "id": "screws",
      "label": "Download STL - Base Foot Screws"
    }
  ]
};
